import React from 'react';
import {_} from "../utils";
import './noCredits.less';


export  default ({ buyUrl, message }) => (
    <div className="no-credits-body">
        <div className="row">
            <div className="col text-center">
                <object data="/images/hercul/kupi_bazu_bg.png" type="image/png">
                    <img src="https://usaherald.com/wp-content/uploads/2017/10/sample.jpg" />
                </object>
            </div>
        </div>
        { 
            message && (
                <div className="row">
                    <div className="col text-center">
                        <h1>{message}</h1>
                    </div>
                </div>
            )
        }
        <div className="row">
            <div className="col">
                <ul className="no-credits-options-list">
                    <li>
                        <i className="fa fa-check-circle fa-2x" aria-hidden="true"></i>
                        <span>{_('Jednostavna brza pretraga')}</span>
                    </li>
                    <li>
                        <i className="fa fa-check-circle fa-2x" aria-hidden="true"></i>
                        <span>{_('Pregledavanje životopisa kategorije')}</span>
                     </li>
                    <li>
                        <i className="fa fa-check-circle fa-2x" aria-hidden="true"></i>
                        <span>{_('Kreiranje vlastite baze')}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div className="row">
            <div className="col"></div>
            <div className="col text-center">
                <a href={buyUrl} className="btn btn-primary">{_('Kupi kredite')}</a>
            </div>
            <div className="col"></div>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/modules/app/NoCredits.js